import React, { useState, useEffect } from 'react';
import { useAuth, apiFetch } from "../hooks/useAuth";
// import {
//     DataGrid, GridRowsProp, GridColDef,
//     GridToolbarContainer, GridToolbarExport, GridActionsCellItem
// } from '@mui/x-data-grid';

import { DataGridPro, GridToolbar, GridToolbarContainer, GridToolbarExport, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid-pro';


import EmailIcon from '@mui/icons-material/Email';
import CircleIcon from '@mui/icons-material/Circle';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

import {
    IconButton, FormControlLabel, Stack, Alert,
    LinearProgress, Box, Modal, Typography, Tooltip
} from "@mui/material/";
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import { ModalDownload, ModalContact } from "./Modal";
import { deDE } from '@mui/x-data-grid-pro/locales'

export const CmdService = ({ index }) => {
    const handleEditClick = () => {
        // some action
    };

    return (
        <FormControlLabel
            control={
                <IconButton
                    color="secondary"
                    aria-label="add an alarm"
                    onClick={handleEditClick}
                >
                    <EmailIcon />
                </IconButton>
            }
        />
    );
};

export function OrderList() {
    const { accountID, token } = useAuth();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState("");
    const [data, setData] = useState([]);
    const [oldestOrderDate, setOldestOrderDate] = useState(null);

    const [currentRow, setCurrentRow] = useState(null);
    const [isModalDownloadOpen, setIsModalDownloadOpen] = useState(false);
    const [isModalContactOpen, setIsModalContactOpen] = useState(false);
    const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [notificationType, setNotificationType] = useState('error'); // 'error' or 'success'


    const apiRef = useGridApiRef();

    // Helper function to show notifications
    const showNotification = (message, type = 'error') => {
        setNotificationMessage(message);
        setNotificationType(type);
        setIsNotificationModalOpen(true);
    };

    const handleStatusClick = (status) => {

        apiRef.current.setFilterModel({

            items: [{ field: 'Bestellstatus', operator: 'contains', value: status }],
        });

    };

    const currencyFormatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
    });

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarExport
                    printOptions={{
                        hideFooter: true,
                        hideToolbar: true,
                    }}
                />
            </GridToolbarContainer>
        );
    }

    useEffect(() => {
        setData([]);

        if (!accountID) {
            setError("Es wurde keine AccountID ausgewaehlt");
            return;
        }

        if (!token) {
            setError("Es gibt keinen definierten User Token");
        }

        setLoading(true);

        // Handle accountID as array - send all selected accounts
        const accountIdString = Array.isArray(accountID) ? accountID.join(',') : accountID;
        apiFetch("/app/orders/" + accountIdString)
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Die Daten konnten nicht geladen werden. ');
                }
                return res.json();
            })
            .then((data) => {
                setLoading(false);
                console.log(data);

                // Add AuftragNr field with same value as Belegnummer
                let processedData = data.map(item => ({
                    ...item,
                    AuftragNr: item.Belegnummer
                }));

                // TODO: Implement 2-year retention policy for completed orders
                // Filter completed orders (delivered/cancelled) older than 2 years
                // This should ideally be handled in the backend/database level
                // TEMPORARILY DISABLED - showing all orders
                // const twoYearsAgo = dayjs().subtract(2, 'years');
                // processedData = processedData.filter(item => {
                //     // Keep all active orders (not delivered/cancelled)
                //     if (item.Bestellstatus !== 'geliefert' && item.Bestellstatus !== 'storniert') {
                //         return true;
                //     }
                //     
                //     // For completed orders, only keep those from the last 2 years
                //     const deliveryDate = item.geliefertAm || item.Bestelldatum1;
                //     if (deliveryDate) {
                //         return dayjs(deliveryDate).isAfter(twoYearsAgo);
                //     }
                //     
                //     // If no delivery date, use order date
                //     return dayjs(item.Bestelldatum1).isAfter(twoYearsAgo);
                // });

                setData(processedData);
                setError("");
                if (data.message)
                    setMessage(data.message);
                
                // Find oldest order date
                if (processedData.length > 0) {
                    const oldestDate = processedData.reduce((oldest, order) => {
                        if (!order.Bestelldatum1) return oldest;
                        const orderDate = dayjs(order.Bestelldatum1, 'DD.MM.YYYY');
                        if (!orderDate.isValid()) return oldest;
                        if (!oldest || orderDate.isBefore(oldest)) {
                            return orderDate;
                        }
                        return oldest;
                    }, null);
                    setOldestOrderDate(oldestDate);
                }
            })
            .catch((err) => {
                setLoading(false);
                setError(err.message);
            });

    }, [accountID]);

    return (
        <div style={{ height: "670px", width: '100%' }}>
            <Box
                mt={2}
                mb={2}
                sx={{ width: '100%', height: 4 }}>
                {loading && <LinearProgress />}
            </Box>

            {!loading && error && <Alert severity="error">{error}</Alert>}
            {!loading && message && <Alert severity="info">{message}</Alert>}
            
            {!loading && oldestOrderDate && (
                <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Bestellungen seit {oldestOrderDate.format('DD.MM.YYYY')}
                    </Typography>
                </Box>
            )}

            <ModalDownload row={currentRow} isModalOpen={isModalDownloadOpen} handleCloseModal={() => setIsModalDownloadOpen(false)} />
            <ModalContact row={currentRow} isModalOpen={isModalContactOpen} handleCloseModal={() => setIsModalContactOpen(false)} />

            {/* Notification Modal */}
            <Modal
                open={isNotificationModalOpen}
                onClose={() => setIsNotificationModalOpen(false)}
                aria-labelledby="notification-modal-title"
                aria-describedby="notification-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography id="notification-modal-title" variant="h6" component="h2">
                            {notificationType === 'error' ? '❌ Fehler' : '✅ Erfolg'}
                        </Typography>
                        <IconButton
                            onClick={() => setIsNotificationModalOpen(false)}
                            sx={{
                                color: 'text.secondary',
                                '&:hover': {
                                    bgcolor: 'rgba(0, 0, 0, 0.04)'
                                }
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Typography id="notification-modal-description" sx={{ mb: 3 }}>
                        {notificationMessage}
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <IconButton
                            onClick={() => setIsNotificationModalOpen(false)}
                            sx={{
                                bgcolor: notificationType === 'error' ? '#f44336' : '#4caf50',
                                color: 'white',
                                '&:hover': {
                                    bgcolor: notificationType === 'error' ? '#d32f2f' : '#388e3c',
                                },
                                px: 3,
                                py: 1,
                                borderRadius: 1,
                            }}
                        >
                            <Typography variant="button">OK</Typography>
                        </IconButton>
                    </Box>
                </Box>
            </Modal>

            <Stack direction="row" alignItems="center" gap={1}
                sx={{ mb: 2, fontSize: "small" }}
            >
                <Box 
                    onClick={() => handleStatusClick("geliefert")} 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 0.5, 
                        cursor: 'pointer',
                        p: 1,
                        borderRadius: 1,
                        '&:hover': { bgcolor: 'action.hover' }
                    }}
                >
                    <CircleIcon sx={{ color: "#ffd700" }} />
                    <Typography color="text.secondary">geliefert</Typography>
                </Box>

                <Box 
                    onClick={() => handleStatusClick("berechnet")} 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 0.5, 
                        cursor: 'pointer',
                        p: 1,
                        borderRadius: 1,
                        '&:hover': { bgcolor: 'action.hover' }
                    }}
                >
                    <CircleIcon sx={{ color: "#228b22" }} />
                    <Typography color="text.secondary">berechnet</Typography>
                </Box>

                <Box 
                    onClick={() => handleStatusClick("bestellt")} 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 0.5, 
                        cursor: 'pointer',
                        p: 1,
                        borderRadius: 1,
                        '&:hover': { bgcolor: 'action.hover' }
                    }}
                >
                    <CircleIcon sx={{ color: "#ab2524" }} />
                    <Typography color="text.secondary">bestellt</Typography>
                </Box>

                <Box 
                    onClick={() => handleStatusClick("storniert")} 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 0.5, 
                        cursor: 'pointer',
                        p: 1,
                        borderRadius: 1,
                        '&:hover': { bgcolor: 'action.hover' }
                    }}
                >
                    <CircleIcon sx={{ color: "grey" }} />
                    <Typography color="text.secondary">storniert</Typography>
                </Box>

            </Stack>

            <div style={{ display: 'flex', height: '100%', width: '100%' }}>
                <div style={{ flexGrow: 1, width: '100%', overflow: 'hidden' }}>
                    <DataGridPro
                        apiRef={apiRef}
                        pageSize={100}
                        autoSizeColumns={true}
                        getRowHeight={() => 'auto'}
                        sx={{ 
                            width: '100%',
                            '& .MuiDataGrid-cell': {
                                fontSize: '0.8rem',
                                py: 1
                            },
                            '& .MuiDataGrid-columnHeader': {
                                fontSize: '0.8rem'
                            },
                            '& .MuiDataGrid-row': {
                                minHeight: '52px !important'
                            }
                        }}
                        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}


                        // getRowId={(row) => row.AuftragNr}
                        // componentsProps={{
                        //     toolbar: {
                        //         showQuickFilter: true,
                        //         quickFilterProps: { debounceMs: 500 },
                        //     },
                        // }}
                        slots={{ toolbar: GridToolbar }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                            },
                            filterPanel: {
                                onKeyDown: (event) => {
                                    console.log(event.key);
                                    if (event.key === 'Enter') {
                                        apiRef.current.hideFilterPanel()
                                    }
                                }
                            }
                        }}

                        initialState={{ pinnedColumns: { right: ['actions'] } }}
                        rows={data}
                        columns={[
                            {
                                field: 'Bestellstatus',
                                headerName: "Status",
                                renderCell: (params) => {
                                    // Determine actual status based on Belegart and Bestellstatus
                                    let actualStatus = params.value;
                                    let color = "";
                                    
                                    // If there's a Rechnung (invoice), the order is considered "berechnet" (billed)
                                    if (params.row.Belegart === 'Rechnung') {
                                        actualStatus = 'berechnet';
                                        color = "#228b22"; // green
                                    } else if (params.value === "geliefert") {
                                        color = "#ffd700"; // yellow
                                    } else if (params.value === "berechnet") {
                                        color = "#228b22"; // green
                                    } else if (params.value === "bestellt") {
                                        color = "#ab2524"; // red
                                    } else if (params.value === "storniert") {
                                        color = "grey";
                                    }

                                    const statusDetail = params.row?.MeldetextKombiniert || actualStatus;
                                    const tooltipTitle = `Status: ${actualStatus} (${statusDetail})`;

                                    return (
                                        <Box sx={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            justifyContent: 'center',
                                            height: '100%',
                                            width: '100%'
                                        }}>
                                            <Tooltip title={tooltipTitle} arrow>
                                                <CircleIcon
                                                    sx={{ "color": color, cursor: "help" }}
                                                />
                                            </Tooltip>
                                        </Box>
                                    );
                                },
                                width: 60
                            },
                            {
                                field: 'Bestelldatum1',
                                headerName: "bestellt am",
                                type: "date",
                                width: 100,
                                valueGetter: (value) => {
                                    if (!value) return null;
                                    
                                    // Handle both formats: YYYY-MM-DD (from backend) and DD.MM.YYYY (legacy)
                                    if (value.includes('-')) {
                                        // Backend format: YYYY-MM-DD
                                        const date = new Date(value);
                                        return isNaN(date.getTime()) ? null : date;
                                    } else if (value.includes('.')) {
                                        // Legacy format: DD.MM.YYYY
                                        const parts = value.split('.');
                                        if (parts.length !== 3) return null;
                                        const date = new Date(parts[2], parts[1] - 1, parts[0]);
                                        return isNaN(date.getTime()) ? null : date;
                                    }
                                    return null;
                                },
                                valueFormatter: (value) => {
                                    if (!value) return '';
                                    // Value is already a Date object from valueGetter
                                    return dayjs(value).format('DD.MM.YYYY');
                                }
                            },
                            {
                                field: "Anzahl",
                                width: 50,
                            },
                            {
                                field: 'Autor',
                                width: 150,
                            },
                            {
                                field: 'Titel',
                                width: 200,
                                renderCell: (params) => {
                                    if (!params.value) return '';
                                    
                                    return (
                                        <div style={{
                                            whiteSpace: 'normal',
                                            wordWrap: 'break-word',
                                            lineHeight: '1.2',
                                            padding: '4px 0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            height: '100%',
                                            fontSize: '0.8rem'
                                        }}>
                                            {params.value}
                                        </div>
                                    );
                                }
                            },
                            {
                                field: 'Einzelpreis',
                                valueFormatter: (params) => {
                                    return currencyFormatter.format(params);
                                },
                                headerName: "Betrag",
                                type: "number",
                                width: 70,
                            },
                            {
                                field: 'Gesamtbetrag',
                                valueFormatter: (params) => {
                                    return currencyFormatter.format(params);
                                },
                                headerName: "Gesamtbetrag",
                                type: "number",
                                width: 70,
                            },
                            {
                                field: 'ISBN',
                                width: 100
                            },

                            {
                                field: 'KDNR',
                                headerName: "Kundennr.",
                                width: 70
                            },
                            {
                                field: 'MeldetextKombiniert',
                                headerName: "Meldetext",
                                width: 120,
                                renderCell: (params) => {
                                    if (!params.value) return '';
                                    
                                    return (
                                        <div style={{
                                            whiteSpace: 'normal',
                                            wordWrap: 'break-word',
                                            lineHeight: '1.2',
                                            padding: '4px 0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            height: '100%',
                                            fontSize: '0.8rem'
                                        }}>
                                            {params.value}
                                        </div>
                                    );
                                }
                            },

                            {
                                field: 'geliefertAm',
                                headerName: "geliefert am",
                                type: "date",
                                width: 100,
                                valueGetter: (value) => {
                                    if (!value) return null;
                                    // Parse German date format (DD.MM.YYYY) from database
                                    const parts = value.split('.');
                                    if (parts.length !== 3) return null;
                                    // Create date as YYYY-MM-DD for proper sorting
                                    const date = new Date(parts[2], parts[1] - 1, parts[0]);
                                    return isNaN(date.getTime()) ? null : date;
                                },
                                valueFormatter: (value) => {
                                    if (!value) return '';
                                    // Value is already a Date object from valueGetter
                                    return dayjs(value).format('DD.MM.YYYY');
                                }
                            },
                            {
                                field: 'Belegart',
                                headerName: "Belegart",
                                width: 70
                            },
                            {
                                field: 'Belegnummer',
                                headerName: "Belegnummer.",
                                width: 70,
                            },
                            {
                                field: 'actions',
                                type: 'actions',
                                headerName: 'Aktionen',
                                width: 80,
                                getActions: (params) => {
                                    const items = [
                                        <Tooltip key="contact" title="Reklamation">
                                            <GridActionsCellItem
                                                onClick={() => {
                                                    setCurrentRow(params.row);
                                                    setIsModalContactOpen(true);
                                                }}
                                                icon={<EmailIcon />} label="Reklamation" />
                                        </Tooltip>
                                    ];

                                    const belegnummer = params.row.Belegnummer;

                                    if (belegnummer && belegnummer !== 0) {
                                        const handleDownload = async () => {
                                            let pdfName = '';

                                            if (params.row.Belegart === 'Rechnung') {
                                                pdfName = `RG_${belegnummer}`;
                                            } else if (params.row.Belegart === 'Lieferschein') {
                                                pdfName = `LS_${belegnummer}`;
                                            } else if (params.row.Belegart === 'Gutschrift') {
                                                pdfName = `GS_${belegnummer}`;
                                            } else {
                                                pdfName = `${params.row.Belegart}${belegnummer}`;
                                            }
                                            let accountIDRow = params.row.KDNR;
                                            try {
                                                const response = await apiFetch(`/app/download/${accountIDRow}/${pdfName}`, {
                                                    headers: {
                                                        "Authorization": "Bearer " + token,
                                                    },
                                                });

                                                if (!response.ok) {
                                                    let errorMessage = 'Download failed';
                                                    try {
                                                        const errorText = await response.text();
                                                        if (errorText) {
                                                            errorMessage = errorText;
                                                        }
                                                    } catch (e) {
                                                        errorMessage = response.statusText || 'Download failed';
                                                    }
                                                    throw new Error(errorMessage);
                                                }

                                                const blob = await response.blob();
                                                const url = window.URL.createObjectURL(blob);
                                                const a = document.createElement('a');
                                                a.href = url;
                                    

                                                const contentDisposition = response.headers.get('Content-Disposition');
                                                const fileName = contentDisposition
                                                    ? contentDisposition.split('filename=')[1]?.replace(/"/g, '')
                                                    : `${pdfName}.pdf`;
                                                
                                                a.download = fileName;
                                                a.click();
                                                window.URL.revokeObjectURL(url);

                                                showNotification(`Dokument ${fileName} wurde erfolgreich heruntergeladen`, 'success');
                                            } catch (error) {
                                                console.error('Download error:', error);
                                                showNotification(error.message, 'error');
                                            }
                                        };

                                        items.push(
                                            <Tooltip key="download" title="Belege herunterladen">
                                                <GridActionsCellItem
                                                    onClick={handleDownload}
                                                    icon={<CloudDownloadIcon />} label="Download" />
                                            </Tooltip>
                                        );
                                    } else {
                                        // Add invisible placeholder to maintain consistent spacing
                                        items.push(
                                            <GridActionsCellItem
                                                key="placeholder"
                                                icon={<CloudDownloadIcon sx={{ visibility: 'hidden' }} />}
                                                label=""
                                                disabled
                                            />
                                        );
                                    }

                                    return items;
                                }
                            }
                        ]}
                    />
                </div>
            </div>
        </div>
    )
}

// Export OrderList as OrderListSchoeningh for compatibility
export { OrderList as OrderListSchoeningh };
